"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.darkTheme = exports.darkThemesOptions = void 0;
// WORK IN PROGRESS
const material_1 = require("@mui/material");
const base_theme_1 = require("./base-theme");
exports.darkThemesOptions = {};
exports.darkTheme = (0, material_1.createTheme)(base_theme_1.baseTheme, exports.darkThemesOptions);
//# sourceMappingURL=dark-theme.js.map